module.exports = __webpack_public_path__ + "img/app-login.8c82ed63.png";